import styled from "styled-components";
import {
	MOBILE_L_BP,
	COLOR_ERROR_RED,
	FONT_WT_BOLD,
	COLOR_BORDER_GREY,
	COLOR_WHITE,
	COLOR_TEXT_PRIMARY_B2C,
	FONT_WT_LIGHT,
} from "@website-builder/utilities-index";

export const EmailFormWrapper = styled.form`
	margin: 45px 0;
	display: flex;
	align-items: center;
	justify-content: center;
	input {
		height: 50px;
		width: 100%;
		border-radius: 3px;
		border: 1px solid ${COLOR_BORDER_GREY};
		font-size: 16px;
		display: inline-block;
		margin-right: 5px;
		padding: 15px;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		box-sizing: border-box;
		&:focus {
			outline: none;
		}
		::placeholder {
			color: ${COLOR_BORDER_GREY};
		}
	}
	.formGroup:first-child {
		margin-right: 10px;
	}
	.formGroupEmail {
		width: 320px;
		position: relative;
		.errorMessageWrapper {
			display: ${(props) => (props.error ? "unset" : "none")};
			.errorIcon {
				font-style: normal;
				top: 50%;
				transform: translateY(-50%);
				background: ${COLOR_ERROR_RED};
				position: absolute;
				right: 16px;
				font-size: 12px;
				display: block;
				font-weight: ${FONT_WT_BOLD};
				height: 16px;
				width: 16px;
				padding-top: 1px;
				color: ${COLOR_WHITE};
				text-align: center;
				border-radius: 8px;
			}
			.errorMessage {
				position: absolute;
				right: -3px;
				bottom: 44px;
				background-color: ${COLOR_ERROR_RED};
				color: ${COLOR_WHITE};
				float: right;
				padding: 2px 10px;
				border-radius: 4px;
				margin-bottom: 9px;
				font-weight: ${FONT_WT_LIGHT};
				font-size: 12px;
				padding: 10px;
				&:after {
					content: "";
					position: absolute;
					right: 20px;
					top: 100%;
					width: 0;
					height: 0;
					border-left: 8px solid transparent;
					border-right: 8px solid transparent;
					border-top: 8px solid ${COLOR_ERROR_RED};
					clear: both;
				}
			}
		}
	}
	.successMessageWrapper {
		display: flex;
		align-items: center;
		img {
			margin-right: 10px;
		}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		display: block;
		.formGroup {
			width: 100%;
			&:first-child {
				margin-bottom: 15px;
			}
		}

		.submitButton {
			width: 100%;
		}

		.successMessageWrapper {
			display: block;
			text-align: center;
			img {
				margin-right: 10px;
			}
			.message {
				display: block;
				line-height: 27px;
			}
		}
	}
`;
